"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _DataManager = _interopRequireDefault(require("./DataManager"));

var _GridTable = _interopRequireDefault(require("./GridTable"));

var _Header = _interopRequireDefault(require("./Header"));

var _Footer = _interopRequireDefault(require("./Footer"));

var _FormsWrapper = _interopRequireDefault(require("./FormsWrapper"));

var _helpers = require("./helpers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Grid = /*#__PURE__*/function (_React$Component) {
  _inherits(Grid, _React$Component);

  var _super = _createSuper(Grid);

  function Grid(props) {
    var _this;

    _classCallCheck(this, Grid);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "openColumnsHideMenu", function () {
      _this.setState({
        columnsHideMenuIsOpen: !_this.state.columnsHideMenuIsOpen
      });
    });

    _defineProperty(_assertThisInitialized(_this), "closeColumnsHideMenu", function () {
      _this.setState({
        columnsHideMenuIsOpen: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "toggleAppealForm", function () {
      _this.setState(function (prevState) {
        return {
          isAppealFormOpened: !prevState.isAppealFormOpened
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "filter", function (val, key) {
      var add = false;

      for (var i in val) {
        if (!add && val.hasOwnProperty(i)) {
          add = add || (val[i] + '').includes(key);
        }
      }

      return add;
    });

    _defineProperty(_assertThisInitialized(_this), "filterData", function (key) {
      var data = _this.props.data;

      _this.setState({
        data: data.filter(function (val) {
          return _this.filter(val, key);
        })
      });
    });

    _defineProperty(_assertThisInitialized(_this), "filterFields", function (field) {
      console.error('function working not correct, need refactoring'); // const { fields } = this.props.params;
      // let newFields = {};
      //
      // if (field !== 'all_fields') {
      //     for (let i in fields) {
      //         if (i === field) {
      //             newFields[i] = fields[i];
      //         }
      //     }
      // } else {
      //     newFields = this.props.params.fields;
      // }
      //
      // this.setState({ params: { ...this.state.params, fields: newFields } });
    });

    _defineProperty(_assertThisInitialized(_this), "selectItem", function (item) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var _this$state = _this.state,
          prevSelected = _this$state.selected,
          multiSelected = _this$state.multiSelected,
          multiSelect = _this$state.multiSelect;
      var params = _this.props.params;

      var selected = _objectSpread({}, item);

      var multi = _toConsumableArray(multiSelected);

      if (params.defaultId) {
        selected.id = item[(0, _helpers.getIdKey)(params)];
      }

      if (multiSelect && e.ctrlKey) {
        var selIndex = multi.findIndex(function (v) {
          return v[(0, _helpers.getIdKey)(params)] === selected.id;
        });

        if (selIndex === -1) {
          multi.push(selected);
        } else multi.splice(selIndex, 1);
      } else multi.splice(0, multi.length, selected);

      if (selected.id || selected.id === 0) {
        _this.setState({
          selected: selected,
          multiSelected: multi
        });

        if (params.selectItem) {
          params.selectItem(selected, multi);
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "transformMultiSelected", function () {
      var multiSelected = _this.state.multiSelected;
      var params = _this.props.params;
      var ids = [];
      multiSelected.forEach(function (v) {
        return ids.push(v[(0, _helpers.getIdKey)(params)]);
      });
      return ids;
    });

    _defineProperty(_assertThisInitialized(_this), "handleSort", function (_ref) {
      var field = _ref.field,
          order = _ref.order;
      var _this$props = _this.props,
          data = _this$props.data,
          sort = _this$props.params.sort; // if it's server side sorting

      if (sort && sort.onChange) return sort.onChange({
        field: field,
        order: order
      }); // if it's simple sorting

      return _this.setState({
        data: data.sort(function (a, b) {
          var direct = order === 'desc' ? 1 : -1;
          return a[field] > b[field] ? direct : -direct;
        }),
        sort: {
          field: field,
          order: order
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleCheck", function (e) {
      var _e$target = e.target,
          value = _e$target.value,
          checked = _e$target.checked;
      var itemId = parseInt(value);
      var _this$props$params$gr = _this.props.params.groups,
          checkedItems = _this$props$params$gr.checkedItems,
          handleCheck = _this$props$params$gr.handleCheck;
      var items = checked ? [].concat(_toConsumableArray(checkedItems), [itemId]) : checkedItems.filter(function (item) {
        return item !== itemId;
      });
      handleCheck({
        checkedItems: items
      });

      if (!checkedItems.length && items.length) {
        _this.setState({
          isAppealFormOpened: true
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "render", function () {
      var _this$state2 = _this.state,
          data = _this$state2.data,
          selected = _this$state2.selected,
          isAppealFormOpened = _this$state2.isAppealFormOpened,
          stateSort = _this$state2.sort,
          columnsHideMenuIsOpen = _this$state2.columnsHideMenuIsOpen,
          gridId = _this$state2.gridId;
      var _this$props2 = _this.props,
          params = _this$props2.params,
          toggleRowVisibility = _this$props2.toggleRowVisibility;
      var classGrid = params.classNames ? "grid ".concat(params.classNames) : 'grid normal';
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: classGrid,
        id: gridId
      }, /*#__PURE__*/_react["default"].createElement(_Header["default"], {
        params: params,
        selected: selected,
        filterData: _this.filterData,
        filterFields: _this.filterFields
      }), /*#__PURE__*/_react["default"].createElement(_GridTable["default"], _extends({
        gridId: gridId,
        params: params,
        data: data,
        selected: selected,
        multiSelected: _this.transformMultiSelected(),
        sort: _objectSpread(_objectSpread(_objectSpread({}, stateSort), params.sort), {}, {
          handleSort: _this.handleSort
        }),
        selectItem: _this.selectItem,
        toggleRowVisibility: toggleRowVisibility,
        columnsMenu: {
          isOpen: columnsHideMenuIsOpen,
          open: _this.openColumnsHideMenu,
          close: _this.closeColumnsHideMenu
        }
      }, _this.props.params.groups && {
        groups: _objectSpread(_objectSpread({}, _this.props.params.groups), {}, {
          handleCheck: _this.handleCheck
        })
      })), /*#__PURE__*/_react["default"].createElement(_Footer["default"], {
        params: params,
        selected: selected
      }), _this.props.params.groups && /*#__PURE__*/_react["default"].createElement(_FormsWrapper["default"], _extends({}, _this.props.params.groups, {
        filterOnlyCheckedItems: _this.filterOnlyCheckedItems,
        toggleAppealForm: _this.toggleAppealForm,
        isAppealFormOpened: isAppealFormOpened
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: columnsHideMenuIsOpen && "popup-window-overlay"
      }));
    });

    var _params = props.params,
        _data = props.data;
    var _params$options = _params.options,
        _selected = _params$options.selected,
        mountSelect = _params$options.mountSelect,
        _multiSelect = _params$options.multiSelect;
    var initialState = {
      data: _data,
      selected: _selected,
      multiSelected: _selected ? [_selected] : [],
      isAppealFormOpened: true,
      mountSelect: mountSelect,
      multiSelect: _multiSelect,
      columnsHideMenuIsOpen: false,
      gridId: Math.floor(Math.random() * 1000)
    };

    if (!_params.sort || !_params.sort.onChange) {
      initialState.sort = {};
    }

    _this.state = initialState;
    return _this;
  }

  _createClass(Grid, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var selected = this.props.params.options.selected;
      var _this$state3 = this.state,
          mountSelect = _this$state3.mountSelect,
          data = _this$state3.data;

      if (mountSelect) {
        this.selectItem(selected || data[0], {});
        this.setState({
          mountSelect: false
        });
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var data = nextProps.data,
          params = nextProps.params; // const { selected } = params.options;
      // const { selected: oldSelected } = this.state;

      this.setState({
        data: data
      }); // if (selected && selected.id !== oldSelected.id) {
      //     this.selectItem(params.options.selected);
      // }
    }
  }]);

  return Grid;
}(_react["default"].Component);

Grid.propTypes = {
  data: _propTypes["default"].array,
  params: _propTypes["default"].object.isRequired,
  // from DataManager
  toggleRowVisibility: _propTypes["default"].func
};

var _default = (0, _DataManager["default"])(Grid);

exports["default"] = _default;